/* eslint-disable no-param-reassign */
import { useDispatch } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';

import { createSelector } from '../../../utils/store';
import FETCH_STATUSES from '../../../constants/fetchStatuses';

export default ({ slicePath, repositoryAction }) => {
  const slice = createSlice({
    name: slicePath.join('/'),
    initialState: {
      data: null,
      loadingState: FETCH_STATUSES.idle,
      error: null,
    },
    reducers: {
      start(state) {
        state.loadingState = FETCH_STATUSES.pending;
      },
      loadSuccess(state, { payload }) {
        state.data = payload;
        state.loadingState = FETCH_STATUSES.fulfilled;
        state.error = null;
      },
      fail(state, { payload }) {
        state.loadingState = FETCH_STATUSES.failed;
        state.data = null;
        state.error = payload;
      },
      reset(state) {
        state.data = null;
        state.meta = {};
        state.loadingState = FETCH_STATUSES.idle;
        state.error = null;
      },
    },
  });

  const {
    actions: { start, fail, loadSuccess, reset },
  } = slice;

  const selectors = {
    getData: createSelector(slicePath, 'data'),
    getLoadingState: createSelector(slicePath, 'loadingState'),
    getError: createSelector(slicePath, 'error'),
  };

  const useActions = () => {
    const dispatch = useDispatch();

    return {
      load: async (...params) => {
        try {
          dispatch(start());
          const result = await repositoryAction(...params);
          const { data } = result;

          dispatch(loadSuccess(data));
        } catch (error) {
          const { response } = error;
          const { status, statusText, data } = response;
          const errorDescription = { status, statusText, errorData: data };

          dispatch(fail(errorDescription));
        }
      },
      reset: () => dispatch(reset()),
    };
  };

  return { slice, selectors, useActions };
};
